import React, { FC, useState } from 'react';
import { ArrowLeftCircle } from 'static';

import { ArrowLeft, ArrowRight, Wrapper } from './styled';

interface GridScrollBlockProps {
  style: { [key: string]: string | number };
  zoom: number;
  onClick: (direction: 'start' | 'end') => void | boolean;
  scrollCount: number;
}

const GridScrollBlock: FC<GridScrollBlockProps> = ({
  style,
  zoom,
  onClick,
  scrollCount,
}) => {
  const [isAnimatingLeft, setIsAnimatingLeft] = useState(false);
  const [isAnimatingRight, setIsAnimatingRight] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  const handleClick = (type: 'start' | 'end') => {
    const result = onClick(type);
    setHasMoreData(result !== false);

    if (type === 'start') {
      setIsAnimatingLeft(true);
      setTimeout(() => {
        setIsAnimatingLeft(false);
      }, 1000);
    } else {
      setIsAnimatingRight(true);
      setTimeout(() => {
        setIsAnimatingRight(false);
      }, 1000);
    }
  };

  return (
    <Wrapper style={style}>
      <ArrowLeft
        onClick={() => handleClick('start')}
        zoom={zoom}
        isAnimating={isAnimatingLeft}
        hasMoreData={hasMoreData}
        scrollCount={scrollCount}
      >
        <ArrowLeftCircle />
      </ArrowLeft>
      <ArrowRight
        onClick={() => handleClick('end')}
        zoom={zoom}
        isAnimating={isAnimatingRight}
        hasMoreData={hasMoreData}
        scrollCount={scrollCount}
      >
        <ArrowLeftCircle />
      </ArrowRight>
    </Wrapper>
  );
};

export default GridScrollBlock;
